import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../shared/dropdownMenu';
import config from '../../config';
import { changeCursorTo, CursorTypes } from '../../utils/changeCursor';
import FileUploadButton from '../../shared/fileUpload/fileUploadButton.component';
import { acceptedExcelFileExtensions } from '../../shared/fileUpload/constants';
import Spinner from '../../shared/spinner.component';

import { generateAssetPath } from '../../utils/assetsHelpers';

class HamburgerMenu extends PureComponent {
  static propTypes = {
    uploadUnavailable: PropTypes.bool.isRequired,
    downloadTemplateUnavailable: PropTypes.bool.isRequired,
    uploadTaxEntriesToImport: PropTypes.func.isRequired,
    templateFileName: PropTypes.string.isRequired,
  };

  componentDidUpdate(prevProps) {
    const isUploadingTaxEntriesToImportChanged = (
      prevProps.uploadUnavailable !== this.props.uploadUnavailable
    );

    if (isUploadingTaxEntriesToImportChanged && !this.props.uploadUnavailable) {
      this.hideDropDown();
      changeCursorTo(CursorTypes.DEFAULT);
    }
  }

  hideDropDown = () => {
    this.dropdown.hideDropDown();
  };

  uploadTaxEntriesToImport = event => {
    const file = event.target.files[0];
    this.props.uploadTaxEntriesToImport(file);
    event.target.value = '';
    changeCursorTo(CursorTypes.WAIT);
  };

  render() {
    const {
      uploadUnavailable,
      downloadTemplateUnavailable,
    } = this.props;

    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        {
          downloadTemplateUnavailable
            ? <span className="disabled">Download Import Template</span>
            : (
              <a
                className="hamburger-action"
                download={this.props.templateFileName}
                href={generateAssetPath(config.templates.BATCH_TAX_ENTRIES)}
              >
                Download Import Template
              </a>
            )
        }

        <FileUploadButton
          accept={acceptedExcelFileExtensions}
          className="upload-file-button hamburger-action"
          disabled={uploadUnavailable}
          onChange={this.uploadTaxEntriesToImport}
        >
          {uploadUnavailable ? (
            <span>
              <Spinner small/> Loading
            </span>
          ) : 'Choose File to Import'}
        </FileUploadButton>
      </DropdownMenu>
    );
  }
}

export default HamburgerMenu;
